export const FETCH_STATIC_TEMPLATE = 'STATIC_EDITOR/FETCH_STATIC_TEMPLATE';
export const FETCH_STATIC_TEMPLATE_SUCCESS = 'STATIC_EDITOR/FETCH_STATIC_TEMPLATE_SUCCESS';
export const FETCH_STATIC_TEMPLATE_ERROR = 'STATIC_EDITOR/FETCH_STATIC_TEMPLATE_ERROR';
export const ADD_TO_CART = 'STATIC_EDITOR/ADD_TO_CART';
export const ADD_TO_CART_SUCCESS = 'STATIC_EDITOR/ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_ERROR = 'STATIC_EDITOR/ADD_TO_CART_ERROR';
export const ADD_FAVORITE = 'STATIC_EDITOR/ADD_FAVORITE';
export const ADD_FAVORITE_SUCCESS = 'STATIC_EDITOR/ADD_FAVORITE_SUCCESS';
export const ADD_FAVORITE_ERROR = 'STATIC_EDITOR/ADD_FAVORITE_ERROR';
export const CHECK_FAVORITE = 'STATIC_EDITOR/CHECK_FAVORITE';
export const CHECK_FAVORITE_SUCCESS = 'STATIC_EDITOR/CHECK_FAVORITE_SUCCESS';
export const CHECK_FAVORITE_ERROR = 'STATIC_EDITOR/CHECK_FAVORITE_ERROR';
export const SET_TEMPLATE_CODE = 'STATIC_EDITOR/SET_TEMPLATE_CODE';
export const SET_QUANTITY = 'STATIC_EDITOR/SET_QUANTITY';
export const SET_PRINTING_OPTION = 'STATIC_EDITOR/SET_PRINTING_OPTION';
export const SET_LANGUAGE = 'STATIC_EDITOR/SET_LANGUAGE';
export const SET_ORIENTATION = 'STATIC_EDITOR/SET_ORIENTATION';
export const SET_MATERIAL_TYPE = 'STATIC_EDITOR/SET_MATERIAL_TYPE';
export const SET_SIZE = 'STATIC_EDITOR/SET_SIZE';
export const SET_TYPE = 'STATIC_EDITOR/SET_TYPE';
export const RESET_STATE = 'STATIC_EDITOR/RESET_STATE';
export const SET_ACTION = 'STATIC_EDITOR/SET_ACTION';